import { profileConstants } from '../constants'

export type ProfileDeleteAction = {
  type: string
  profileDeleteSw: boolean
}

export type ProfilePasswordChangeAction = {
  type: string
  profilePasswordChangeSw: boolean
}

const profileDeleteSw = (state: boolean = false, action: ProfileDeleteAction) => {
  switch (action.type) {
    case profileConstants.DELETE:
      return action.profileDeleteSw
    default:
      return state
  }
}

const profilePasswordChangeSw = (state: boolean = false, action: ProfilePasswordChangeAction) => {
  switch (action.type) {
    case profileConstants.PASSWORD_CHANGE:
        return action.profilePasswordChangeSw
    default:
      return state
  }
}

export {
  profileDeleteSw,
  profilePasswordChangeSw
}